/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import PropTypes from 'prop-types';
import { FeatureToggles } from '@paralleldrive/react-feature-toggles';
import { useTranslation } from 'react-i18next';
import { Amplify } from 'aws-amplify';
// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';

import './themes';
import outputs from './aws-exports';
import { useFeatures } from './hooks/useFeatures';
import buildTheme from './themes/muiTheme';

Amplify.configure(outputs);

I18n.putVocabularies(translations);

const AppWrapper = ({ children }) => {
  const theme = useSelector(store => store.theme.industry);
  const { data: features } = useFeatures();
  const { i18n, t } = useTranslation();

  const muiTheme = useMemo(() => buildTheme(t), [t]);

  useEffect(() => {
    I18n.setLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <FeatureToggles features={Array.isArray(features) ? features : []}>
      <ThemeProvider theme={{ industry: theme }}>
        <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
      </ThemeProvider>
    </FeatureToggles>
  );
};

AppWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AppWrapper;
